export function obtenerCodigoUsuario() {
  const usuarioStr = localStorage.getItem('usuario');
  if (!usuarioStr) return null; // No hay información del usuario

  try {
    const usuario = JSON.parse(usuarioStr);
    // Verificar si el usuario tiene el rol de administrador
    const esAdmin = usuario.roles.some((rol) => rol.Codigo === 4);
    if (esAdmin) {
      // No enviar código de usuario si es administrador
      return null;
    }

    // Retornar el Código del usuario si no es administrador
    return usuario.Codigo;
  } catch (error) {
    console.error('Error al analizar la información del usuario:', error);
    return null; // Manejo de error, por si acaso hay un problema al analizar
  }
}
